module.exports = __webpack_public_path__ + "img/minMaterial.baa670da.png";